import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'
import { kebabCase } from 'lodash'

export class PremiumInvoiceActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'document_recipient': 'dispatchType',
        'files.name': 'textList',
        'invoice_date': 'date',
        'matched_contract_confirmed': 'boolean',
    }

    static getLogDetailsCreated (activityLog, data) {
        const logDetails = [];

        [
            'invoice_number',
            'framework_agreement_number',
            'invoice_date',
            'document_recipient',
        ].forEach (attribute => {
            if (activityLog.properties.attributes[attribute]) {
                logDetails.push (
                    {
                        key: attribute,
                        label: i18n.tc(`forms.field.label.premium-invoice.${kebabCase(attribute)}`, 1),
                        newValue: this.getFormattedLogDetailValue(activityLog, attribute, this.attributeDataTypes[attribute] ?? 'undefined', activityLog.properties.attributes[attribute]),
                    }
                )
            }
        })

        return logDetails
    }

    static getLogDetailsDeleted (activityLog, data) {
        const logDetails = [];

        [
            'invoice_number',
            'framework_agreement_number',
            'invoice_date',
            'document_recipient',
        ].forEach (attribute => {
            if (activityLog.properties.old[attribute]) {
                logDetails.push (
                    {
                        key: attribute,
                        label: i18n.tc(`forms.field.label.premium-invoice.${kebabCase(attribute)}`, 1),
                        oldValue: this.getFormattedLogDetailValue(activityLog, attribute, this.attributeDataTypes[attribute] ?? 'undefined', activityLog.properties.old[attribute]),
                    }
                )
            }
        })

        return logDetails
    }
}
